// extracted by mini-css-extract-plugin
export default {"content":"Impressum_content__wALIl"};